<div class="title">
    {{ "catalog_filter_categories_title" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "catalog_filter_category_label" | translate }}
        </label>
        <div class="col-xs-12 mb-5">
            <input class="form-control" [formControl]="label" />
        </div>
        <div class="col-xs-4">
            <sp-input-num
                suffixText="px"
                [min]="FONT_SIZE_MIN"
                [max]="FONT_SIZE_MAX"
                [onlyIntegers]="true"
                [value]="categoryLabelFontSettingsFormGroup.controls.fontSize.value"
                (valueChange)="setFontSize(settingsType.categoryLabel, $event)"
            ></sp-input-num>
        </div>
        <div class="col-xs-6 mb-10">
            <div class="btn-group btn-group-justified" data-toggle="buttons">
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.categoryLabel, EFontStyle.AT)"
                    (click)="toggleActiveTextStyle(settingsType.categoryLabel, EFontStyle.AT)"
                >
                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.categoryLabel, EFontStyle.B)"
                    (click)="toggleActiveTextStyle(settingsType.categoryLabel, EFontStyle.B)"
                >
                    <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.categoryLabel, EFontStyle.I)"
                    (click)="toggleActiveTextStyle(settingsType.categoryLabel, EFontStyle.I)"
                >
                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                </label>
            </div>
        </div>
        <div class="col-xs-2">
            <sp-color-picker
                hideGradient
                [color]="categoryLabelFontSettingsFormGroup.controls.color.value"
                (colorChangeEvent)="setTextColor(settingsType.categoryLabel, $event)"
            >
            </sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "catalog_filter_category_list_Label" | translate }}
        </label>
        <div class="col-xs-4">
            <sp-input-num
                suffixText="px"
                [min]="FONT_SIZE_MIN"
                [max]="FONT_SIZE_MAX"
                [onlyIntegers]="true"
                [value]="categoryFontSettingsFormGroup.controls.fontSize.value"
                (valueChange)="setFontSize(settingsType.category, $event)"
            ></sp-input-num>
        </div>
        <div class="col-xs-6 mb-10">
            <div class="btn-group btn-group-justified" data-toggle="buttons">
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.category, EFontStyle.AT)"
                    (click)="toggleActiveTextStyle(settingsType.category, EFontStyle.AT)"
                >
                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.category, EFontStyle.B)"
                    (click)="toggleActiveTextStyle(settingsType.category, EFontStyle.B)"
                >
                    <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(settingsType.category, EFontStyle.I)"
                    (click)="toggleActiveTextStyle(settingsType.category, EFontStyle.I)"
                >
                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                </label>
            </div>
        </div>
        <div class="col-xs-2">
            <sp-color-picker
                hideGradient
                [color]="categoryFontSettingsFormGroup.controls.color.value"
                (colorChangeEvent)="setTextColor(settingsType.category, $event)"
            >
            </sp-color-picker>
        </div>
    </div>

    @if (catalogView === CatalogCategoriesView.left) {
        <div class="form-group mb-20">
            <label class="col-xs-12">
                {{ "catalog_filter_selected_category_label" | translate }}
            </label>
            <!-- <div class="col-xs-4">
      <sp-input-num
        suffixText="px"
        [min]="FONT_SIZE_MIN"
        [max]="FONT_SIZE_MAX"
        [value]="selectedCategoryFontFormGroup.controls.fontSize.value"
        (valueChange)="setFontSize(settingsType.current, $event)"
      ></sp-input-num>
    </div> -->
            <div class="col-xs-6 mb-10">
                <div class="btn-group btn-group-justified" data-toggle="buttons">
                    <label
                        class="btn btn-grey"
                        [class.active]="isActiveTextStyle(settingsType.current, EFontStyle.AT)"
                        (click)="toggleActiveTextStyle(settingsType.current, EFontStyle.AT)"
                    >
                        <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                    </label>
                    <label
                        class="btn btn-grey"
                        [class.active]="isActiveTextStyle(settingsType.current, EFontStyle.B)"
                        (click)="toggleActiveTextStyle(settingsType.current, EFontStyle.B)"
                    >
                        <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                    </label>
                    <label
                        class="btn btn-grey"
                        [class.active]="isActiveTextStyle(settingsType.current, EFontStyle.I)"
                        (click)="toggleActiveTextStyle(settingsType.current, EFontStyle.I)"
                    >
                        <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                    </label>
                </div>
            </div>
            <div class="col-xs-2">
                <sp-color-picker
                    hideGradient
                    [color]="selectedCategoryFontFormGroup.controls.color.value"
                    (colorChangeEvent)="setTextColor(settingsType.current, $event)"
                >
                </sp-color-picker>
            </div>
        </div>
    }

    @if (catalogView === CatalogCategoriesView.top) {
        <div class="form-group mb-20">
            <label class="col-xs-12">
                {{ "control_fields_appearance" | translate }}
            </label>
            <div class="col-xs-12">
                <div class="btn-group d-flex">
                    <button
                        class="btn btn-grey w-100"
                        [class.active]="borderStyle.value === inputBorderEnum.FULL_BORDER"
                        (click)="setBorderStyle(inputBorderEnum.FULL_BORDER)"
                    >
                        <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                    </button>
                    <button
                        class="btn btn-grey w-100"
                        [class.active]="borderStyle.value === inputBorderEnum.BOTTOM_BORDER"
                        (click)="setBorderStyle(inputBorderEnum.BOTTOM_BORDER)"
                    >
                        <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                    </button>
                </div>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_input_text_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="textColor.value"
                    (colorChangeEvent)="setTextColor(settingsType.category, $event)"
                ></sp-color-picker>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_background_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="backgroundColor.value"
                    (colorChangeEvent)="setBackgroundColor($event)"
                ></sp-color-picker>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_border_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="borderColor.value"
                    (colorChangeEvent)="setBorderColor($event)"
                ></sp-color-picker>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-6 control-label">
                {{ "control_radius" | translate }}
            </label>
            <div class="col-xs-6">
                <sp-input-num
                    prefixImgUrl="./assets/img/border-radius-icon.svg"
                    suffixText="px"
                    [min]="BORDER_RADIUS_MIN"
                    [max]="BORDER_RADIUS_MAX"
                    [onlyIntegers]="true"
                    [value]="borderRadius.value"
                    (valueChange)="setBorderRadius($event)"
                    (blurEvent)="setBorderRadius($event)"
                ></sp-input-num>
            </div>
        </div>
        <div class="form-group mb-0">
            <label class="col-xs-6 control-label">{{ "control_fields_size" | translate }}</label>
            <div class="col-xs-6">
                <sp-radio-group
                    [selected]="inputSize.value"
                    [type]="ERadioGroupType.size"
                    (changeSelectedEvent)="setInputSize($event)"
                ></sp-radio-group>
            </div>
        </div>
    }

    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider" />
        </div>
    </div>
</div>
